export const isNullOrEmptyOrUndefined = (
  field: unknown
): field is null | '' | undefined => {
  return field === null || field === '' || field === undefined;
};

export const isDefined = <T>(field: T | null | undefined): field is T => {
  return field !== null && field !== undefined;
};

export const isDefinedOrThrow = <T>(
  value: T | null | undefined,
  valueName?: string
): T => {
  if (isDefined(value)) {
    return value;
  }
  // eslint-disable-next-line functional/no-throw-statement
  throw new Error(`${valueName || 'A value'} is not defined`);
};
